export const userPositions = {
  GeneralManager: 'GeneralManager',
  Accounting: 'Accounting',
  FrontDesk: 'FrontDesk',
  AGM: 'AGM',
  Corporate: 'Corporate',
  DOS: 'DOS',
  ItPms: 'ItPms',
  GuestReviewRater: 'GuestReviewRater',
  FrontDeskManager: 'FrontDeskManager',
  RevenueContact: 'RevenueContact',
  Unknown: 'Unknown'
}

export const userPositionNames = {
  Corporate: 'Corporate',
  GeneralManager: 'General Manager',
  AGM: 'Assistant General Manager',
  DOS: 'Sales & Marketing',
  FrontDesk: 'Front Desk',
  FrontDeskManager: 'Front Desk Manager',
  Accounting: 'Billing Contact',
  RevenueContact: 'Revenue Contact',
  ItPms: 'IT/PMS',
  GuestReviewRater: 'Guest Review Rater',
  Unknown: 'Staff'
}
